"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var lazyload_image_directive_1 = require("./lazyload-image.directive");
var LazyLoadImageModule = (function () {
    function LazyLoadImageModule() {
    }
    LazyLoadImageModule = __decorate([
        core_1.NgModule({
            declarations: [lazyload_image_directive_1.LazyLoadImageDirective],
            exports: [lazyload_image_directive_1.LazyLoadImageDirective]
        })
    ], LazyLoadImageModule);
    return LazyLoadImageModule;
}());
exports.LazyLoadImageModule = LazyLoadImageModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng-lazyload-image/src/lazyload-image.module.js
// module id = 314
// module chunks = 0